import React, { useState, useEffect } from "react";
import { Col, Row, Image, Card, Button, Modal, Typography, Tabs, Empty } from "antd";
import "antd/dist/reset.css";
import "../containers/customLayout.css";
import '../App.css';
import userGuideService from "../services/userGuideService";
import { recordError } from '../utils/logService';
import { programmes } from "../utils/apiConstants";

import {
  Messages,
  Notify,
  openNotification, 
  ParagraphHeader,
  pdfjsVersion,
  util
} from '@seims/shared';

import {
  FileTextOutlined
} from "@ant-design/icons";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout"; 

import { Viewer, Worker } from "@react-pdf-viewer/core";
import YoutubeUserGuides from "./media/YoutubeUserGuides";

const { Title, Paragraph } = Typography;


const UserGuideView = () => {
  const initWidth = 650;
  const emptyString = "";
  const tabList = programmes
    .filter((programme) => programme.active === true)
    .map((programme) => ({ key: programme.key, label: programme.value }));

  tabList.unshift({
    key: "seims-public",
    label: "General",
  });

  const [userGuides, setUserGuides] = useState([{}]);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(emptyString);
  const [previewTitle, setPreviewTitle] = useState(emptyString);
  const modalWidth = initWidth;
  const [currentTab, setCurrentTab] = useState("events-tracker");
  const [currentTitle, setCurrentTitle] = useState("SEIMS Events App");
  const documentModule =
    currentTab === "seims-public" ? "all-public" : currentTab;


  useEffect(() => {
    loadUserGuides(documentModule);
  }, [documentModule]);

  const loadUserGuides = async (moduleName) => {
    let msg;

    try {
      const response = await userGuideService.getUserGuides(moduleName);
      console.log("RESPONSE", response);
      if (response && response.status === 200) {
        const { data } = response;
        setUserGuides(data);
      } else if (response && response.status === 204) {
        setUserGuides([]);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.UPDATE_FAILURE, "Load User Guides");
      openNotification("Load User Guides", msg, Notify.ERROR);
      recordError(error);
    }
  };

  const onTabChange = (selected) => {
    const title =
      tabList.find((tab) => tab.key === selected)?.label || "General";
    setCurrentTab(selected);
    setCurrentTitle(title);
  };

  const handlePreviewDocument = async (id, document) => {
    try {
      const response = await userGuideService.downloadFile(id);
      if (response) {
        const { data } = response;
        const new_blob = new Blob([data]);
        const url = URL.createObjectURL(new_blob);

        setPreviewImage(url);
        setPreviewOpen(true);
        setPreviewTitle(document.filename);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const handleCancel = () => setPreviewOpen(false);

  const handleDownloadDocument = async (id, filename) => {
    let msg;
    try {
      const response = await userGuideService.downloadFile(id);

      if (response) {
        const { data } = response;
        const new_blob = new Blob([data]);

        const url = URL.createObjectURL(new_blob);
        const downloadLink = document.createElement("a");

        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.FILEDOWNLOAD_FAILURE, "File");
      openNotification("File Download", msg, Notify.ERROR);
      recordError(error);
    }
  };

  return (
    <>
      <Row
        justify="center"
        className="page-header"
        style={{ marginBottom: 10 }}
      >
        <Col xs={12} md={6} lg={4}>
          <div>
            <Image
              style={{ textAlign: "center" }}
              preview={false}
              src={require("../assets/userGuide.png")}
              alt="User Guides"
            />
          </div>
        </Col>
      </Row>
      <Row
        justify="center"
        style={{ paddingBottom: 30 }}
        className="faq-page public-portal-page"
      >
        <Col lg={18} xs={24}>
          <ParagraphHeader header={`User Guides | ${currentTitle}`} />
          <Tabs
            onChange={onTabChange}
            items={tabList}
            key="repo-table-1"
            activeKey={currentTab}
          />
        </Col>
      </Row>
      <YoutubeUserGuides currentTab={currentTab} />
      <Row
        justify="center"
        style={{ paddingBottom: 30 }}
        className="public-portal-page user-guides-page"
      >
        <Col lg={18} xs={24} style={{ height: "100%" }}>
          <Title level={3}>SEIMS Document Guides</Title>
          {/* <Paragraph>
            View and Download documents about specific user.
          </Paragraph>{" "} */}
          <Row gutter={[16, 16]} className="card-section">
            {userGuides.length > 0 ? (
              userGuides.map((item, index) => (
                <Col key={index} xs={24} sm={12} md={8} lg={6}>
                  <Card className="guide-card">
                    <h3 className="guide-title">
                      <FileTextOutlined
                        style={{
                          fontSize: "21px",
                          color: "#1F6297",
                          paddingBottom: "10px",
                        }}
                      />{" "}
                      {item.filename}
                    </h3>

                    <Row className="guide-buttons">
                      <Col>
                        {" "}
                        <Button
                          type="primary"
                          shape="round"
                          onClick={() => handlePreviewDocument(item.uuid, item)}
                        >
                          View
                        </Button>
                      </Col>
                      <Col>
                        {" "}
                        <Button
                          style={{ marginLeft: 15 }}
                          type="primary"
                          shape="round"
                          onClick={() =>
                            handleDownloadDocument(item.uuid, item?.filename)
                          }
                        >
                          Download
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))
            ) : (
              <Col span={24}>
                <Empty description="No user guides available" />
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <Modal
        key={"modal-preview"}
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={modalWidth}
      >
        <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion()}/build/pdf.worker.min.js`}
        >
          <Viewer
            fileUrl={previewImage}
            plugins={[defaultLayoutPluginInstance]}
            renderError={console.log}
          />
        </Worker>
      </Modal>
    </>
  );
}

export default UserGuideView;